
<template>
    <div class="x_page">

        <Tab :data='data'>
            <template #x0>
                <Ssdt />
            </template>
            <template #x1>
                <Zywg />
            </template>
            <template #x2>
                <Bmtj />
            </template>
            <template #x3>
                <Sjtb />
            </template>
            <template #x4>
                <Rdfx />
            </template>
            <template #x5>
                <three />
            </template>
        </Tab>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import axios from "axios";
// import echarts from 'echarts'
// import overview from "./components/overview/index"
// import estate from "./components/estate/index"
// import cheif from "./components/cheif/index"
// import event from "./components/event/index"
import Ssdt from './ssdt'
import Zywg from './wgpmsj'
import Bmtj from './bmbltj'
import Sjtb from './sjsltb'
import Rdfx from './rdfx'
import Tab from './components/tab'

import three from './disanfang'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {Tab,Ssdt,Zywg,Bmtj,Sjtb,Rdfx,three},
    data() {
    //这里存放数据
        return {
            data: [{label:'实时动态'},{label:'专业网格排名统计'},{label:'部门办理统计'},{label:'事件受理同比'},{label:'热点分类'},{label:'事项图谱'}]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        clickTab(index){
            this.selectIndex = index
        },
        getWeather(){
            axios({
                url:this.urlobj.getWeather+'?area=濮阳',
                headers:{
                    Authorization: "APPCODE b0ca862be8e8409a91d735179f4d07ed"
                },
                method:'get',
                
            }).then(res=>{
                 console.log('success',res)
                 res = res.data
                    let data = res.showapi_res_body.now
                    this.weather = '空气质量'+data.aqiDetail.quality+'  '+data.weather+'  '+data.temperature+'℃'
                    this.weatherPic = data.weather_pic
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
           
        })
         window.onresize = ()=> {
            // let clientHeight = this.$refs['carousel_wrapper_div'].clientHeight
            // this.carousel_height = clientHeight+'px';
        };
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {
        
        window.onresize = null
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.x_page {
    width: 100%;
    height: 100%;
    background:url('../../assets/dongxiang/bk.jpg') no-repeat;
    background-size: 100% 100%;
}


</style>